const PasswordSymbol = () => {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.67982 6.6482L2.18382 8.2322L1.31982 6.7442L3.95982 5.4002L1.31982 4.0562L2.18382 2.5682L4.67982 4.1522L4.53582 1.2002H6.26382L6.11982 4.1522L8.61583 2.5682L9.47983 4.0562L6.83982 5.4002L9.47983 6.7442L8.61583 8.2322L6.11982 6.6482L6.26382 9.6002H4.53582L4.67982 6.6482Z"
        fill="#1A1919"
      />
    </svg>
  );
};

export default PasswordSymbol;
